import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Menopauze, en nu?</title>
                <link rel="canonical" href={route("blogs.thirty-three")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog lees je alles over de menopauze. We gaan dieper in op wat de menopauze is, de meest voorkomende klachten en hoe je dit kunt oplossen. Lees je met ons mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog lees je alles over de menopauze. We gaan dieper in op wat de menopauze is, de meest voorkomende klachten en hoe je dit kunt oplossen. Lees je met ons mee?"
                />
                <meta property="og:url" content={route("blogs.thirty-three")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Menopauze, en nu? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/menopauze.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/menopauze.webp"
                                    type="image/webp"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/menopauze.jpg"
                                    type="image/jpeg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/menopauze.jpg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Menopauze, en nu?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE Personal Training Uden en Schijndel komt met een
                        nieuwe blog. In deze blog lees je alles over de
                        menopauze. We gaan dieper in op wat de menopauze is, de
                        meest voorkomende klachten en hoe je dit kunt oplossen.
                        Lees je met ons mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is de menopauze?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De menopauze is de laatste menstruatie van een vrouw.
                        Het is een natuurlijk lichamelijk proces waarna de
                        menstruele cyclus stopt en de vrouw onvruchtbaar wordt.
                        De periode rondom deze menopauze wordt de{" "}
                        <a
                            href={route("blogs.eighteenth")}
                            className="text-we-are-yellow"
                        >
                            overgang
                        </a>{" "}
                        genoemd. Wanneer een vrouw een jaar geen menstruatie
                        meer heeft gehad zit ze in de postmenopauze. De meeste
                        voorkomende leeftijd van de menopauze is rond het 50ste
                        levensjaar.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom hebben veel vrouwen last van deze fase?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor en na de menopauze, ook wel de overgang genoemd,
                        zoeken hormonen weer balans. Deze periode wordt
                        gekenmerkt door een aanzienlijke daling in eicellen,
                        verandering in de cyclus en klachten zoals opvliegers en
                        gewichtstoename. Ongeveer 80% van de vrouwen ondervindt
                        klachten van de overgang. Deze periode kan maanden, soms
                        zelf jaren duren en tijdens deze fase kan een vrouw nog
                        altijd zwanger worden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Na deze fase komt de vrouw in de menopauze terecht, het
                        einde van de menstruatie. Kenmerkend aan de fase zijn
                        dat de vrouw niet meer vruchtbaar is en dat het lichaam
                        gestopt is met het aanmaken van oestrogeen en
                        progesteron. Ook heeft een vrouw hogere kans op hart,-
                        en vaatziekten tijdens deze periode.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer een vrouw de menopauze heeft gepasseerd breekt
                        de postmenopauze aan. In deze fase zullen na verloop van
                        tijd de overgangsklachten langzaam gaan afnemen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is het mogelijk om gewicht te verliezen in de overgang?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De overgang maakt afvallen niet makkelijk, dat weten we.
                        Gemiddeld komen vrouwen in de overgang acht tot tien
                        kilo aan. Echter maakt de overgang afvallen ook niet
                        onmogelijk! Wanneer je goed voor je lichaam en je
                        gezondheid zorgt, is het mogelijk om ook gewicht af te
                        vallen tijdens je overgang. Wij adviseren om je pijlen
                        te richten om zo min mogelijk aan te komen! Om deze
                        reden geven we handige tips om een enorme toename te
                        voorkomen
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        1. Eet gezond en vermijd junkfood
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is belangrijk dat je gezond gaat of blijft eten. Je{" "}
                        <a
                            href={route("blogs.twenty-one")}
                            className="text-we-are-yellow"
                        >
                            metabolisme
                        </a>{" "}
                        vertraagt tijdens de overgang en dus zal je sneller in
                        een calorie overschot komen door ongezond eten. Blijf af
                        van gefrituurd eten en kies voor genoeg groente en
                        fruit!
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        2. Doe aan krachttraining
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Het grootste voordeel aan krachttraining is dat je
                        spieren blijven behouden. Dit is cruciaal als je jouw
                        metabolisme op peil wil houden! Verder behoudt je
                        soepele gewrichten en sterke botten.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        3. Neem een koude douche
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Koud douchen brengt vele voordelen met zich mee zoals
                        het versterken van je immuunsysteem. Verder helpt het
                        bij het opbouwen van bruin vet, een vetsoort die
                        makkelijker te verbranden is voor het lichaam om warmte
                        vrij te maken.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        4. Vermijd alcohol
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        <a
                            href={route("blogs.nineteenth")}
                            className="text-we-are-yellow"
                        >
                            Alcohol
                        </a>{" "}
                        is gif voor ons lichaam maar gelukkig hebben we onze
                        lever. Echter is je lever als erg druk met
                        hormoonregulatie tijdens de overgang. Laat hem dus met
                        rust en stop met het drinken van alcohol.
                    </p>
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        5. Haal adem
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Ademhaling is onze beste manier is van{" "}
                        <a
                            href={route("blogs.first")}
                            className="text-we-are-yellow"
                        >
                            stress
                        </a>{" "}
                        af te komen. Door middel van onze ademhaling kunnen we
                        onze cortisol waardes laten dalen. De bijnieren, die
                        deze cortisol aanmaken hebben het al veel te druk
                        tijdens de overgang. Zij nemen namelijk een stukje taak
                        over van de eierstokken door kleine hoeveelheden
                        oestrogeen te produceren. Al jouw{" "}
                        <a
                            href={route("blogs.first")}
                            className="text-we-are-yellow"
                        >
                            stress
                        </a>{" "}
                        zorgt ervoor dat de bijnieren dit niet goed kunnen doen.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
